import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  margin-top: 4px;

  font-size: 14px;
  color: ${Colors.GS550};
  line-height: 21px;
`
